import appConstants from "../../../../../appConstants";
import { MultiSelectFilter } from "../../../../dataGrid/columnFilters";
import { convertMinutesToHHMM } from "../NextStopComplianceUtills";

class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration();
  }

  static formatTime(params) {
    const value = params.data[params.column.colId];
    return convertMinutesToHHMM(value);
  }

  static formatCompliancePercentage(params) {
    return `${params.data.compliancePercentage}%`;
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.NextStopCompliance,
      keyColumn: "routeName",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        lockPinned: true,
        sortable: true,
        filter: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Route Compliance",
          field: "compliancePercentage",
          valueFormatter: GridConfig.formatCompliancePercentage,
          headerTooltip: "Route Compliance",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_ROUTE,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Driver",
          field: "driverName",
          headerTooltip: "Driver",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_DRIVER_NAME,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Driver Number",
          field: "driverNumber",
          headerTooltip: "driverNumber",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_ROUTE,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Route",
          field: "routeName",
          headerTooltip: "Route",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_ROUTE,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Manifest #",
          field: "manifestNumber",
          headerTooltip: "Manifest #",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_MANIFEST,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Optimization Deviation",
          field: "deviationCount",
          headerTooltip: "Optimization Deviation",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_DRIVER_NAME,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Total Stops",
          field: "totalStops",
          headerTooltip: "Total Stops",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_TOTAL_TIME,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Total Bills",
          field: "totalBills",
          headerTooltip: "Total Bills",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_TOTAL_TIME,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Total Time",
          field: "totalTime",
          valueGetter: GridConfig.formatTime,
          headerTooltip: "Total Time",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_ROUTE,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Total Miles",
          field: "totalMiles",
          headerTooltip: "Total Miles",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_TOTAL_TIME,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Extra Miles Added",
          field: "extraMiles",
          headerTooltip: "Extra Miles Added",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_ROUTE,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Additional Time",
          field: "extraTime",
          valueGetter: GridConfig.formatTime,
          headerTooltip: "Additional Time",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_ROUTE,
          filterFramework: MultiSelectFilter,
        },
        {
          headerName: "Missed Apts",
          field: "missedApts",
          headerTooltip: "Missed Apts",
          minWidth: appConstants.columnWidth.NEXT_STOP_COMPLIANCE_MANIFEST,
          filterFramework: MultiSelectFilter,
        },
      ],
    };
  }
}

export default GridConfig;
